import { EventEmitter } from 'eventemitter3';
import { get_interceptor_config } from './helper_functions';
export class Interception extends EventEmitter {
    constructor(interceptor, fn, websocketHandler) {
        super();
        this.interceptor = interceptor;
        this.fn = fn;
        this.websocketHandler = websocketHandler;
    }
    async validateInterception() {
        return await get_interceptor_config(this.interceptor, this.websocketHandler).then((config) => {
            this.interceptorData = config;
        }).catch((error) => {
            throw error;
        });
    }
    reconnect() {
        console.log("reconnecting interceptor " + this.interceptor);
        this.validateInterception();
    }
    createResponse(config, id, ref_id, channel, namespace, event, pipeline_id, interceptor_name, attempt_id, type, content) {
        const { thread_id, node_id, agent_node_id, agent_id, environment_id, to_username, configuration_id, root_workflow_id } = config;
        return {
            ...config,
            channel: channel,
            namespace: namespace,
            event: event,
            id: id,
            ref_id: ref_id,
            return_flag: type,
            pipeline_id: pipeline_id,
            interceptor_name: interceptor_name,
            attempt_id: attempt_id,
            thread_id,
            node_id,
            agent_node_id,
            agent_id,
            environment_id,
            to_username,
            configuration_id,
            root_workflow_id,
            content: JSON.stringify(content),
        };
    }
    execute(request) {
        this.acknowledge(request);
        const { id, channel, namespace, from, to, event, interceptor_name, pipeline_id, attempt_id, ref_id, data: rawData, thread_id, node_id, agent_node_id, agent_id, environment_id, to_username, configuration_id, root_workflow_id } = request;
        const config = {
            channel,
            namespace,
            event,
            interceptor_name,
            from,
            to,
            to_username,
            thread_id,
            node_id,
            agent_node_id,
            agent_id,
            environment_id,
            configuration_id,
            root_workflow_id,
        };
        const resolve = (data) => {
            var _a;
            if (data === null || typeof data !== 'object') {
                console.error("Invalid data: Expected a JSON object or array of objects.", data);
                return;
            }
            if (data.hasOwnProperty("attempt_id") || data.hasOwnProperty("pipeline_id")) {
                data = (_a = data.data) !== null && _a !== void 0 ? _a : {};
            }
            const response = this.createResponse(config, id, ref_id, channel, namespace, event, pipeline_id, interceptor_name, attempt_id, "resolve", data);
            this.websocketHandler.sendMessage(JSON.stringify(response));
        };
        const reject = (error) => {
            if (typeof error !== 'string') {
                throw new Error('Error must be a string');
            }
            const errorResponse = {
                rawData,
                error
            };
            const response = this.createResponse(config, id, ref_id, channel, namespace, event, pipeline_id, interceptor_name, attempt_id, "reject", errorResponse);
            this.websocketHandler.sendMessage(JSON.stringify(response));
        };
        this.fn(request, resolve, reject);
    }
    acknowledge(request) {
        const { id, from, channel, namespace, to, pipeline_id, attempt_id, interceptor_name, ref_id, data, thread_id, node_id, agent_node_id, agent_id, environment_id, to_username, configuration_id, root_workflow_id } = request;
        const response = {
            channel: channel,
            namespace,
            id: id,
            ref_id,
            from,
            to,
            to_username,
            return_flag: "IA",
            pipeline_id: pipeline_id,
            interceptor_name: interceptor_name,
            attempt_id: attempt_id,
            thread_id,
            node_id,
            agent_node_id,
            agent_id,
            environment_id,
            configuration_id,
            root_workflow_id,
            content: JSON.stringify(data)
        };
        this.websocketHandler.sendMessage(JSON.stringify(response));
    }
    /**
     * Internal method to handle incoming messages for this subscription.
     * @param event The event name.
     * @param data The data received.
     */
    async handleMessage(channel, data) {
        try {
            data['data'] = JSON.parse(data['data']);
            this.execute(data);
        }
        catch (err) {
            throw err;
        }
    }
}
